import { render, staticRenderFns } from "./ClientEmailEventsModal.vue?vue&type=template&id=400471a1&scoped=true&"
import script from "./ClientEmailEventsModal.vue?vue&type=script&lang=js&"
export * from "./ClientEmailEventsModal.vue?vue&type=script&lang=js&"
import style0 from "./ClientEmailEventsModal.vue?vue&type=style&index=0&id=400471a1&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "400471a1",
  null
  
)

export default component.exports